export const AVATAR_API = "https://ui-avatars.com/api";
export const STRAPI_API = process.env.NODE_ENV !== 'development' ? "https://backend.pmp-online.net/strapi-stripe" : "http://localhost:1337/strapi-stripe";
export const API = process.env.NODE_ENV !== 'development' ? "https://backend.pmp-online.net/api" : "http://localhost:1337/api";
export const API_BASE = process.env.NODE_ENV !== 'development' ? "https://backend.pmp-online.net" : "http://localhost:1337";
export const AUTH_TOKEN = "pmp_authToken";
export const EXPIRE_DATE = "pmp_expireDate";
export const BEARER = "Bearer";
export const USER_E = "pmp_userE"